<template>
  <div class="index">
    <div class="waifu">

      <!-- 提示框 -->
      <div class="waifu-tips"></div>

      <!-- 看板娘画布 -->
      <canvas id="live2d" class="live2d"/>

      <!-- 工具栏 -->
      <div class="waifu-tool">
        <p class="fui-home">
          <a-icon type="home" @click="$router.push('/dashboard/workplace')"/>
        </p>
        <p class="fui-chat">
          <a-icon type="cloud-upload" />
        </p>
        <p class="fui-eye">
          <a-icon type="swap" />
        </p>
        <p class="fui-user">
          <a-icon type="experiment" />
        </p>
        <p class="fui-photo">
          <a-icon type="camera" />
        </p>
        <p class="fui-info-circle">
          <a-icon type="message" />
        </p>
        <p class="fui-cross">
          <a-icon type="close" />
        </p>
      </div>

    </div>
  </div>
</template>

<script>
  import '@/assets/live2d/waifu-tips'
  import '@/assets/live2d/live2d'
  // import '@/assets/live2d/waifu.css'
  import { initModel } from '@/assets/live2d/waifu-tips'
  export default {
    name: 'PhyLive2d',
    components: {
    },
    data() {
      return {
      }
    },
    mounted () {
      live2d_settings['modelId'] = 5;                  // 默认模型 ID
      live2d_settings['modelTexturesId'] = 1;          // 默认材质 ID
      /* 在 initModel 前添加 */
      initModel(require("@/assets/live2d/waifu-tips.json"))
    },
    computed:{
    },
    methods: {
    }
  }
</script>

<style  scoped>
@import url('../../assets/live2d/waifu.css');
  .waifu-tool p i {
    cursor: pointer;
  }

</style>
